<template>
	<view class="f_c_c_c">
		<image :src="imgUrl" :style="{width:width,height:height,marginTop:marginTop}" ></image>
		<text style="color: rgb(154 154 154)!important;font-size: 26rpx;">{{content}}</text>
		<up-button v-if="isShowBtn" type="primary" style="margin-top: 50rpx;width: 30%;border-radius: 100rpx;" :color="vuex_skinColor" @click="goToShop">{{btnContent}}</up-button>
	</view>
</template>

<script setup>
	import {getCurrentInstance, reactive, ref} from "vue";
	import {fnImgRequestPath} from "@/utils/utils";
	
	// 获取Vue实例上下文
	const {ctx} = getCurrentInstance();
	// 定义 Props
	const props = defineProps({
	  imgUrl: {
	    type: String,  
	    default: () => '/static/images/newImg003_03.jpg'
	  },
	  content: {
	    type: String,  
	    default: () => '当前什么都没有~'
	  },
	  width: {
	    type: String,  
	    default: () => '200rpx'
	  },
	  height: {
	    type: String,  
	    default: () => '200rpx'
	  },
	  marginTop: {
	    type: String,  
	    default: () => '200rpx'
	  },
	  btnContent: {
		  type: String,
		  default: () => '去逛逛'
	  },
	  isShowBtn: {
		  type: Boolean,
		  default: () => false
	  }
	});
	function goToShop(){
		ctx.$u.vuex('vuex_pageCur', 'shop');
		// 跳转到首页
		uni.switchTab({
			url: '/pages/index/index'
		})
	}
</script>

<style lang="scss" scoped>
</style>